module.exports = __webpack_public_path__ + "img/premium-crown.55c0abc3.svg";